<script>
	import { onMount } from 'svelte'
	import { slide } from 'svelte/transition'

	/*
		Dropdown with Multiple checkbox select with jQuery - May 27, 2013
		(c) 2013 @ElmahdiMahmoud
		license: https://www.opensource.org/licenses/mit-license.php
	*/
	export let isFunds = false
	export let isTeam = false
	export let isGeographies = false
	export let store
	// export let spac
	export let zIndex = 1
	export let items = []
	// console.log(items)
	
	if(isFunds || isTeam) {
		items = items.reverse()
	}
	// if(isTeam) {
	// 	items.unshift(...items.splice(items.findIndex( el => {
	// 		if(spac){
	// 			if (el.slug === 'advisors') {
	// 				el.name = "Board & Advisors"
	// 				return true;
	// 			}
	// 		} else {
	// 			if (el.slug === 'investment-team') {
	// 				return true;
	// 			}
	// 		}
	// 	}), 1 ))
	// }
	export let allLabel = "Select"
	const jq = window.$

	let current;

	if(store) {
		store.subscribe(value => {
			if(value)
				current = value;
		});
	}

	let _list
	onMount(() => {
		jq(document).bind('click', function (e) {
			var $clicked = jq(e.target)
			if (!$clicked.parents().hasClass(allLabel.toLowerCase().replace(/\s+/g, '-'))) {
				jq(_list).hide()
				open = false;
			}
		})
	})
	let open
</script>

<dl class="dropdown {allLabel ? allLabel.toLowerCase().replace(/\s+/g, '-'):''}" style="z-index: {zIndex}">
	<dt class="d-flex justify-content-between align-items-center" class:open={open} on:click={()=> {
		open = !open
		jq(_list).slideToggle('fast')
	}}>
		<p class="multiSel">{@html typeof(current) != 'string' && current != null ? current.name : allLabel}</p>
		<svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M1 1L5.5 5L10 1" stroke="black" stroke-width="2"/>
		</svg>
		<span class="nav-indicator" class:show={open} aria-hidden="true" />
	</dt>

	<dd in:slide="{{duration: 350, y:-20}}">
		<div class="multiSelect">
			<ul bind:this={_list}>
				{#if !isTeam}
					<!-- {#if typeof(current) !== 'undefined' && current.slug !== null} -->
						<li on:click={() => {
							store.set({name:allLabel, slug:null}) 
							jq(_list).hide()
							open = false;
						}}>
							{isGeographies ? "Global" : allLabel}
						</li>
					<!-- {/if} -->
				{/if}
				{#each items as item}
					<!-- {#if typeof(current) === 'undefined' || current.slug !== item.slug} -->
						<li on:click={() => {
							store.set(item)
							jq(_list).hide()
							open = false;
						}}>
							{@html item.name}
						</li>
					<!-- {/if} -->
				{/each}

				{#if isTeam}
				<li on:click={() => {
					store.set({name:allLabel, slug:null}) 
					jq(_list).hide()
					open = false;
				}}>
					{isGeographies ? "Global" : allLabel}
				</li>
				{/if}
				<span class="nav-indicator" aria-hidden="true" />
			</ul>
		</div>
	</dd>
	<!-- <button>Filter/Clear</button> -->
</dl>